import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { HttpClientService } from 'src/app/@shared/services/http-client/http-client.service';
import { LogService } from 'src/app/@shared/services/log/log.service';
import { RoutePlanning } from '../interfaces/route-planning/@route-planning.interface';
import { GetRouteRequest } from '../interfaces/route-planning/service/@route-planning-service.interface';
import { environment } from 'src/environments/environment';
import { HttpHandler, HttpParams } from '@angular/common/http';
import { SpecialMessage } from '../interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { AgencyContactInfo } from '../interfaces/route-planning/agency-contact-info.interface';
import { Price } from '../interfaces/route-planning/price.interface';
import { Rating } from '../interfaces/route-planning/rating.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class RoutePlanningRepository {
  constructor(
    private readonly httpClientService: HttpClientService,
    httpHandler: HttpHandler,
    languageService: LanguageService
  ) {
    this.httpClientService = new HttpClientService(httpHandler, languageService);
    this.httpClientService.apiUrl = environment.location_service_url;
  }

  getRoutesFromApi(
    body: GetRouteRequest
  ): Observable<ServiceResponse<RoutePlanning[]>> {
    LogService.logInfo('getRoutesFromApi body', body);
    return this.httpClientService.mot_post('RoutePlanning/GetRoutes', body);
  }

  getAgencyContactInfo(
    agencyId: number
  ): Observable<ServiceResponse<AgencyContactInfo>> {
    return this.httpClientService.mot_get(
      'RoutePlanning/GetAgencyContactInfo',
      new HttpParams().append('agencyId', agencyId)
    );
  }

  addRouteToCalendar(
    route: RoutePlanning,
    email: string,
    originName: string,
    destinationName: string
  ): Observable<ServiceResponse<string>> {
    return this.httpClientService.mot_post('RoutePlanning/AddRouteToCalendar', {
      route,
      email,
      originName,
      destinationName,
    });
  }
}
